import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ProfileSettings } from './ProfileSettings';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { 
  User, 
  SignOut, 
  Gear, 
  Key,
  CaretDown,
  UserCircle
} from '@phosphor-icons/react';

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showProfileSettings, setShowProfileSettings] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-primary hover:bg-primary/5 transition-all"
            data-testid="user-menu-trigger"
          >
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
              <User weight="duotone" className="w-4 h-4 text-primary" />
            </div>
            <span className="hidden sm:inline font-medium">{user?.name}</span>
            <CaretDown weight="bold" className="w-3 h-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56" data-testid="user-menu-dropdown">
          {/* User Info Header */}
          <div className="px-3 py-2 border-b border-border">
            <p className="font-medium text-foreground">{user?.name}</p>
            <p className="text-xs text-muted-foreground">{user?.email}</p>
          </div>
          
          {/* Menu Items */}
          <DropdownMenuItem 
            onClick={() => setShowProfileSettings(true)}
            className="cursor-pointer gap-2"
            data-testid="user-menu-profile"
          >
            <UserCircle weight="duotone" className="w-4 h-4" />
            Profilul Meu
          </DropdownMenuItem>
          
          <DropdownMenuItem 
            onClick={() => setShowProfileSettings(true)}
            className="cursor-pointer gap-2"
            data-testid="user-menu-change-password"
          >
            <Key weight="duotone" className="w-4 h-4" />
            Schimbă Parola
          </DropdownMenuItem>
          
          <DropdownMenuSeparator />
          
          <DropdownMenuItem 
            onClick={handleLogout}
            className="cursor-pointer gap-2 text-destructive focus:text-destructive"
            data-testid="user-menu-logout"
          >
            <SignOut weight="bold" className="w-4 h-4" />
            Deconectare
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Profile Settings Dialog */}
      <ProfileSettings 
        open={showProfileSettings} 
        onOpenChange={setShowProfileSettings} 
      />
    </>
  );
}
